import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { AffiliateService } from '@core/services/affiliate.service';
import { Observable } from 'rxjs';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-search-card',
    templateUrl: './search-card.component.html',
    styleUrls: ['./search-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchCardComponent {
  search: String = '';
  affiliates$: Observable<any[]> = this.affiliateService.getAll();
  isMobile: boolean = window.innerWidth <= 991;
  
  faExternalLink = faExternalLink;

  constructor(private affiliateService: AffiliateService) {};

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth <= 991;
  };

  groupAffiliates(affiliates: any[]): any[] {
    return affiliates;
  };
};